/* StudioGradeFitness: product page helpers
   1. Turns description sections (each h2/h3 and what follows) into collapsible
      sections. Default: collapsible on phones only; desktop shows them fully open
      as plain headings. "Tabs" mode (window.__sgfDescTabs, set per product in
      snippets/sgf-enquire.liquid): collapsible rows with icons on all screen sizes,
      matching the product info tabs below, with the first two sections open.
   2. Shows a sticky "Enquire" bar on phones once the main button scrolls away,
      hiding it again when the enquiry form is reached. */
(function () {
  if (window.__sgfProductMobile) return;
  window.__sgfProductMobile = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var OPEN_IN_TABS_MODE = 2;
  var CHEVRON =
    '<span class="sgf-acc__chevron" aria-hidden="true"><svg viewBox="0 0 10 6" width="12" height="8"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z"/></svg></span>';

  var S = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">';
  var ICONS = {
    features: S + '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z"/></svg>',
    included: S + '<path d="M3.5 7.5L12 3.5l8.5 4v9L12 20.5l-8.5-4z"/><path d="M3.5 7.5L12 11.5l8.5-4M12 11.5v9"/></svg>',
    specs: S + '<rect x="4" y="3.5" width="16" height="17" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>',
    warranty: S + '<path d="M12 3.5l7.5 3v5.5c0 4.3-3.2 7.3-7.5 8.5-4.3-1.2-7.5-4.2-7.5-8.5V6.5z"/><path d="M8.8 12.2l2.2 2.2 4.2-4.4"/></svg>',
    delivery: S + '<path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>',
    other: S + '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5M12 8h.01"/></svg>'
  };

  function iconFor(text) {
    var t = (text || '').toLowerCase();
    if (/feature|highlight/.test(t)) return ICONS.features;
    if (/included|in the box/.test(t)) return ICONS.included;
    if (/spec|dimension/.test(t)) return ICONS.specs;
    if (/warrant|guarantee/.test(t)) return ICONS.warranty;
    if (/deliver|assembl|install/.test(t)) return ICONS.delivery;
    return ICONS.other;
  }

  function isTabs(desc) { return desc.classList.contains('sgf-acc--tabs'); }

  function setOpenState(desc) {
    var sections = desc.querySelectorAll(':scope > details.sgf-acc');
    sections.forEach(function (d, i) {
      if (isTabs(desc)) d.open = i < OPEN_IN_TABS_MODE;
      else d.open = mq.matches ? i === 0 : true;
    });
  }

  function buildAccordion(desc) {
    if (desc.hasAttribute('data-sgf-acc')) return;
    desc.setAttribute('data-sgf-acc', '');
    var kids = Array.prototype.slice.call(desc.children);
    var isHeading = function (el) { return /^H[234]$/.test(el.tagName); };
    if (kids.filter(isHeading).length < 2) return;
    var tabs = window.__sgfDescTabs === true;
    if (tabs) desc.classList.add('sgf-acc--tabs');

    var current = null;
    kids.forEach(function (el) {
      if (isHeading(el)) {
        current = document.createElement('details');
        current.className = 'sgf-acc';
        var summary = document.createElement('summary');
        var body = document.createElement('div');
        body.className = 'sgf-acc__body';
        desc.insertBefore(current, el);
        if (tabs) summary.insertAdjacentHTML('beforeend', '<span class="sgf-acc__icon" aria-hidden="true">' + iconFor(el.textContent) + '</span>');
        summary.appendChild(el);
        summary.insertAdjacentHTML('beforeend', CHEVRON);
        current.appendChild(summary);
        current.appendChild(body);
        summary.addEventListener('click', function (e) {
          if (!isTabs(desc) && !mq.matches) e.preventDefault();
        });
      } else if (current) {
        current.querySelector('.sgf-acc__body').appendChild(el);
      } else {
        el.classList.add('sgf-acc-intro');
      }
    });

    // Tabs mode: move a closing italic note (e.g. a safety note) to the end of the
    // first tab, which is open by default, so it stays visible without splitting the tabs.
    if (tabs && current) {
      var last = current.querySelector('.sgf-acc__body').lastElementChild;
      if (last && last.tagName === 'P' && last.children.length === 1 &&
          /^(EM|I)$/.test(last.firstElementChild.tagName) &&
          last.textContent.trim() === last.firstElementChild.textContent.trim()) {
        last.classList.add('sgf-acc-outro');
        desc.querySelector(':scope > details.sgf-acc .sgf-acc__body').appendChild(last);
      }
    }
    setOpenState(desc);
  }

  function initAccordions() {
    document.querySelectorAll('.product__description:not([data-sgf-acc])').forEach(buildAccordion);
  }

  var listen = mq.addEventListener ? function (fn) { mq.addEventListener('change', fn); } : function (fn) { mq.addListener(fn); };
  listen(function () {
    document.querySelectorAll('.product__description[data-sgf-acc]:not(.sgf-acc--tabs)').forEach(setOpenState);
  });

  function initSticky() {
    var bar = document.querySelector('.sgf-sticky');
    if (!bar || bar.__sgfInit) return;
    bar.__sgfInit = true;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    var ticking = false;

    function update() {
      ticking = false;
      var trigger = document.querySelector('.sgf-enquire');
      var form = document.getElementById('sgf-enquiry');
      if (!trigger || !mq.matches) { bar.classList.remove('is-visible'); return; }
      var passedButton = trigger.getBoundingClientRect().bottom < 0;
      var reachedForm = form ? form.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', passedButton && !reachedForm);
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    initAccordions();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Dawn re-renders parts of the product section on variant change.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; initAccordions(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
